import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddContentsToGroupMutationVariables = Types.Exact<{
  data: Types.ModifyEntitiesInGroupInput;
}>;


export type AddContentsToGroupMutation = { addContentsToGroup?: { dynamicallyPresentEntityIds: Array<string> } | null };


export const AddContentsToGroupDocument = /*#__PURE__*/ gql`
    mutation addContentsToGroup($data: ModifyEntitiesInGroupInput!) {
  addContentsToGroup(data: $data) {
    dynamicallyPresentEntityIds
  }
}
    `;

export function useAddContentsToGroupMutation() {
  return Urql.useMutation<AddContentsToGroupMutation, AddContentsToGroupMutationVariables>(AddContentsToGroupDocument);
};